module.exports = __webpack_public_path__ + "static/media/purpleTick.829dcc15.svg";